import { IconProps } from './types';

export const EmbedIcon = (props: IconProps) => (
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20.792 13.861'>
    <path
      // eslint-disable-next-line max-len
      d='M15.317,19.494,17.4,21.573l6.931-6.931L17.4,7.712,15.317,9.791l4.851,4.851Zm-2.772-9.7L10.465,7.712,3.535,14.643l6.931,6.931,2.079-2.079L7.693,14.643Z'
      transform='translate(-3.535 -7.712)'
      fill='#fff'
      {...props}
    />
  </svg>
);
